import React, { lazy } from 'react';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: 'https://cdn.magicpatterns.com/uploads/7woRHUauhRrvPAtp5ssTYa/Portada_Tomo_1_MockUp.png',
  title: 'Tomo 1 — El Módulo Semilla',
  subtitle: 'Tu Primera Casa: 35m² que Cambian Todo',
  desc: 'Planta completa: estar-comedor, dormitorio, baño y cocina-lavadero. Construí en etapas sin demoler.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/dAdFPt2emB2L2Ehwqby2kt/Portada_Tomo_2_MockUp.png',
  title: 'Tomo 2 — La Primera Expansión',
  subtitle: 'De 35m² a 55m²: Tu Segundo Dormitorio Sin Demoler Nada',
  desc: 'Ampliá el Módulo Semilla con un segundo dormitorio sin interrumpir tu vida diaria.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/2hiFPhyiNszkXL4kQyjgsT/Portada_Tomo_3_MockUp.png',
  title: 'Tomo 3 — La Vivienda Familiar',
  subtitle: '72m²: El Segundo Baño que Cambia la Vida Familiar',
  desc: 'Dos baños, cocina independiente y lavadero. Espacio real para una familia de cuatro.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/i5Pr9PGAxKzkzsUyJx8ak3/Portada_Tomo_4_MockUp.png',
  title: 'Tomo 4 — La Vivienda Premium',
  subtitle: '95m²: Suite Matrimonial, 3 Dormitorios y Terminaciones de Valor',
  desc: 'Suite con vestidor, tres dormitorios y terminaciones que aumentan el valor del inmueble.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/ujQP7xnR8mrEdR9XVvsaX5/Portada_Tomo_5_MockUp.png',
  title: 'Tomo 5 — El Kit del Corralón',
  subtitle: 'Cómputo y Presupuesto Exacto para Tu Obra',
  desc: 'Calculá cuánto material necesitás antes de ir al corralón. Sin presupuestos inflados.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/2jHRxWVU7VJusvep4KCDsf/Portada_Tomo_6_MockUp.png',
  title: 'Tomo 6 — El Manual de Obra',
  subtitle: 'Supervisá Tu Construcción Sin Ser Experto',
  desc: 'Controlá el avance, verificá la calidad y evitá que te cobren de más.'
}];
const includes = ['Distribución completa con medidas reales', 'Lista de materiales lista para el corralón', 'Presupuesto orientativo actualizado', 'Orden de construcción por etapa', 'Errores más comunes y cómo evitarlos', 'Decisiones de diseño explicadas en lenguaje de propietario', 'Conexión con los tomos anteriores y siguientes', '100% adaptado al mercado argentino actual'];
export function ProductOverview() {
  return <section id="sistema" className="py-20 bg-beige" data-id="element-299">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-300">
        <div className="text-center mb-16" data-id="element-301">
          <h2 className="text-sm font-bold tracking-widest text-gold uppercase mb-4" data-id="element-302">
            ZENTRAL PRO™ — PACK CI 6×6
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-charcoal" data-id="element-303">
            6 Tomos + 4 Bonos
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-304">
            Construí con claridad desde el día uno y evitá decisiones que salen
            caras.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-beige-dark overflow-hidden" data-id="element-305">
          <div className="p-6 md:p-12" data-id="element-306">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-0 divide-y lg:divide-y-0 lg:gap-y-12" data-id="element-307">
              {tomos.map((tomo, i) => <div key={i} className="flex gap-6 py-8 lg:py-0 relative" data-id="element-308">
                  <div className="shrink-0 relative" data-id="element-309">
                    <img src={tomo.icon} alt={tomo.title} className="w-24 md:w-32 object-contain rounded shadow-md" loading="lazy" decoding="async" data-id="element-310" />
                    <div className="absolute -top-3 -left-3 w-8 h-8 rounded-full bg-gold text-white flex items-center justify-center font-bold text-sm shadow-lg border-2 border-white" data-id="element-311">
                      {i + 1}
                    </div>
                  </div>
                  <div className="flex flex-col justify-center" data-id="element-312">
                    <h5 className="font-bold text-lg md:text-xl text-charcoal mb-1" data-id="element-313">
                      {tomo.title}
                    </h5>
                    <p className="text-gold font-medium text-sm md:text-base mb-2" data-id="element-314">
                      {tomo.subtitle}
                    </p>
                    <p className="text-gray-600 text-sm md:text-base leading-relaxed" data-id="element-315">
                      {tomo.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-12 lg:mt-16 pt-12 border-t border-beige-dark" data-id="element-316">
              <h5 className="font-serif font-bold text-2xl mb-8 text-center text-charcoal" data-id="element-317">
                Cada tomo incluye:
              </h5>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8 max-w-4xl mx-auto" data-id="element-318">
                {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-319">
                    <CheckCircle2 className="w-6 h-6 text-gold shrink-0" data-id="element-320" />
                    <span className="text-base text-gray-700 font-medium" data-id="element-321">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="mt-12 text-center" data-id="element-322">
              <a href="#precios" className="inline-block w-full sm:w-auto text-center bg-terracotta hover:bg-terracotta-light text-white font-bold py-4 px-10 rounded shadow-md hover:shadow-lg transition-all text-lg" data-id="element-323">
                → ACCEDER AHORA
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}